import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import ItemId from "../../../../../../gd-ui/id/item-id"

// const debug = "FieldTaskId_TableCell"
const debug = false

export default function FieldTaskId_TableCell(props:FieldTableCellProps) {
    return (
        <div className="cell-flex" style={getTableCellStyle(props)}>
            {props.listItem.task.shortId &&
                <ItemId itemId      = {props.listItem.task.shortId}
                        itemUrl     = "t/"
                        itemUrlId   = {props.listItem.task.id}
                        itemName    = "Task"
                        copyId      = {true}
                        copyUrl     = {true} />
            }
        </div>
    )
}

